import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "key-country-indicator-form" }
const _hoisted_2 = { class: "key-country-indicator-form__list" }
const _hoisted_3 = { class: "key-country-indicator-form__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSingleComponentCheckbox = _resolveComponent("SelectSingleComponentCheckbox")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InputBlock, {
        title: "Страна",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectSingleComponentCheckbox, {
            modelValue: _ctx.localItem.countryId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localItem.countryId) = $event)),
            options: _ctx.partnerCountryList,
            valueProp: "id",
            trackBy: "name",
            labelOptions: "name",
            required: ""
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _createVNode(_component_InputBlock, {
        title: "Год",
        required: "",
        class: "key-country-indicator-form__item_dense"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ComponentInput, {
            modelValue: _ctx.localItem.year,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localItem.year) = $event)),
            mod: "redesigned",
            type: "number",
            min: "0",
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_InputBlock, {
        title: "Ключевой показатель",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectSingleComponentCheckbox, {
            modelValue: _ctx.localItem.indicatorId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localItem.indicatorId) = $event)),
            options: _ctx.indicatorsList,
            valueProp: "value",
            trackBy: "name",
            labelOptions: "name",
            required: ""
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "key-country-indicator-form__item_empty" }, null, -1)),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (position) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: position }, [
          _createVNode(_component_InputBlock, {
            title: _ctx.getSubjectRfTitle(position),
            required: "",
            class: "key-country-indicator-form__item_region"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSingleComponentCheckbox, {
                modelValue: _ctx.localItem[_ctx.getSubjectRfKey(position)],
                "onUpdate:modelValue": ($event: any) => ((_ctx.localItem[_ctx.getSubjectRfKey(position)]) = $event),
                options: _ctx.regionsList,
                valueProp: "id",
                trackBy: "name",
                labelOptions: "name",
                required: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 2
          }, 1032, ["title"]),
          _createVNode(_component_InputBlock, {
            title: "Значение",
            required: "",
            class: "key-country-indicator-form__item_dense"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ComponentInput, {
                modelValue: _ctx.localItem[_ctx.getSubjectRfValueKey(position)],
                "onUpdate:modelValue": ($event: any) => ((_ctx.localItem[_ctx.getSubjectRfValueKey(position)]) = $event),
                mod: "redesigned",
                type: "number",
                required: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)
        ], 64))
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ButtonComponent, {
        mod: "gradient-bg",
        onClick: _ctx.save,
        disabled: _ctx.isLoading
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("Сохранить", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_ButtonComponent, {
        mod: "border",
        onClick: _ctx.close,
        disabled: _ctx.isLoading
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Отмена ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}